import { useEffect } from 'react'
import { Roboto_Condensed } from 'next/font/google'
import localFont from 'next/font/local'

import { useLoaderStore } from '@/store/loader'

const roboto = Roboto_Condensed({
  weight: ['400', '500', '600'],
  subsets: ['latin']
})

export type ThemeProps = Partial<{
  fluid: boolean
}>

const MonumentExtended = localFont({
  src: [
    {
      path: './fonts/MonumentExtended-Regular.woff2',
      weight: '400',
      style: 'normal'
    }
  ]
})

// eslint-disable-next-line no-unused-vars
const Theme = ({ fluid = true }: ThemeProps) => {
  const setLoaderState = useLoaderStore((state) => state.setState)

  useEffect(() => {
    document.fonts.ready.then(() => {
      console.log('Fonts are ready')
      setLoaderState({ fontsReady: true })
    })
  }, [setLoaderState])

  return (
    <style jsx global>{`
      :root {
        --font-family-roboto: ${roboto.style.fontFamily};
        --font-family-monument: ${MonumentExtended.style.fontFamily};

        --font-size: ${fluid ? `clamp(10px, ${(10 / 1920) * 100}vw, 11.5px)` : `10px`};
      }
    `}</style>
  )
}

export default Theme
